import type {GetPagePreviewsForPosterResponse} from '@Panels/design-page-selector/design-page-selector.types';

export const fetchPageDataInBulk = async (posterId: string, isMounted: boolean): Promise<GetPagePreviewsForPosterResponse | null> => {
  try {
    const response = (await window.PMW.readLocal('poster/getPagePreviewsForPoster', {
      posterHashedId: posterId,
    })) as GetPagePreviewsForPosterResponse;

    if (!isMounted) {
      return null;
    }

    if (!response) {
      console.error('Bad response when trying to get page previews for poster');
      return null;
    }

    if (!response.pageIds.length) {
      console.error('Unable to get page data for poster with id', posterId);
      return null;
    }

    return response;
  } catch (error) {
    console.error('Failed to fetch page data:', error);
    return null;
  }
};

export const fetchMissingPreviews = async (
  posterId: string,
  existingPreviewUrls: Record<string, string>,
  missingPageIds: string[],
  isMounted: boolean
): Promise<Record<string, string> | null> => {
  try {
    const previewPromises = missingPageIds.map(async (pageId) => {
      const url = (await window.PMW.readLocal('poster/getPosterPagePreviewUrl', {
        posterHashedId: posterId,
        pageHashedId: pageId,
      })) as string;
      return [pageId, url] as const;
    });

    const previewEntries = await Promise.all(previewPromises);

    if (!isMounted) {
      return null;
    }

    const updatedPreviewUrls = {...existingPreviewUrls};
    for (const [pageId, url] of previewEntries) {
      updatedPreviewUrls[pageId] = url;
    }

    return updatedPreviewUrls;
  } catch (error) {
    console.error('Failed to fetch missing preview URLs:', error);
    return null;
  }
};
